import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTeamEventUpdateContext } from '../context/TeamEventUpdateContext'

type Props = {
  event: wowaudit.Event
}

const EventPlanningModeTabs = ({ event }: Props) => {
  const { updateEvent, setAllActivitiesActive } = useTeamEventUpdateContext()

  const handleValueChange = async (value: string) => {
    const scope = value as wowaudit.Event['raidsPlanningScope']
    await updateEvent({ raidsPlanningScope: scope })
    if (scope === 'single' && !event.activities.some((a) => a.active)) {
      await setAllActivitiesActive(true)
    }
  }

  return (
    <Tabs
      value={event.raidsPlanningScope}
      onValueChange={(value) => void handleValueChange(value)}
    >
      <TabsList>
        <TabsTrigger value='single'>Single setup</TabsTrigger>
        <TabsTrigger value='per_encounter'>Per encounter</TabsTrigger>
      </TabsList>
    </Tabs>
  )
}

export default EventPlanningModeTabs
